import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import RichTextEditorCustomContextMenu from 'Components/UI/RichTextEditorCustomContextMenu';
import useDebounce from 'Hooks/useDebounce';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-between',
  },
  actions: {
    marginTop: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
  },
  actionButton: {
    margin: theme.spacing(0, 1),
  },
  addNoteText: {
    fontWeight: theme.typography.fontWeightBold,
    flexGrow: 1,
  },
  timelineButton: {
    fontWeight: theme.typography.fontWeightBold,
    flexShrink: 0,
  },
  noteEditor: {
    marginTop: theme.spacing(1),
    flex: 1,
  },
  templateSelectContainer: {
    paddingBottom: 0,
    width: '60%',
    paddingRight: theme.spacing(1),
    alignSelf: 'center',
    '& div.MuiSelect-select': {
      padding: theme.spacing(1),
    },
    '& label': {
      transform: 'translate(14px, 10px) scale(1)',
    },
  },
  templateHeader: {
    display: 'flex',
    width: '60%',
    justifyContent: 'flex-end',
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
  },
});

function NoteWithContextMenu({
  className,
  classes,
  noteResource,
  height,
  handleSaveNote,
  setSaved,
  setResource,
  content,
  note,
  ...rest
}) {
  const applyAutoSave = useDebounce((value) => {
    handleSaveNote(noteResource.copy().attr('content', value));
  });

  const updateNote = (v) => {
    setResource(noteResource.attr('content', v));
    applyAutoSave(v);
    setSaved('unsaved');
  };

  return (
    <div
      className={classNames(classes.root, className)}
      style={{ minHeight: height, maxHeight: height }}
    >
      <RichTextEditorCustomContextMenu
        className={classes.noteEditor}
        onChange={updateNote}
        value={content}
        {...rest}
      />
    </div>
  );
}

NoteWithContextMenu.defaultProps = {
  className: '',
};

NoteWithContextMenu.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  height: PropTypes.number.isRequired,
  noteResource: PropTypes.object.isRequired,
  handleSaveNote: PropTypes.func.isRequired,
  setSaved: PropTypes.func.isRequired,
  setResource: PropTypes.func.isRequired,
};

export default withStyles(styles)(NoteWithContextMenu);
